import {
	connect
} from 'react-redux'
import SimpleDataTable from '../components/common/SimpleDataTable.jsx';
import {
	findOrderDetailList,
	deleteOrderDetail,
	findOrderDetail,
	findGearSpecIdsByGearName,
	changeShowSpecIdHasLabel
} from '../actions';

const mapStateToProps = (state) => ({
	data: state.getIn(['orderDetailListReducer', 'orderDetailList']),
	fields: {
		order_detail_id: '編號',
		customer_gear_name: '產品名稱-客製',
		quantity: '訂貨數量',
		spec_id: '料號',
		model_name: '型號'
	},
    keys: ['order_id', 'order_detail_id', 'gear_name'],
    showDelete: true
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	refresh: () => {
		// if (ownProps.orderId) {
		// 	dispatch(findOrderDetailList({orderId:ownProps.orderId}));			
		// }
	},
	deleteItem:(pk) => {
		dispatch(deleteOrderDetail(pk));
		dispatch(findOrderDetailList({orderId:pk.order_id}));
	},
	onClick:(pk) => {
		dispatch(findOrderDetail(pk));
		dispatch(findGearSpecIdsByGearName({gear_name: pk.gear_name}));
		dispatch(changeShowSpecIdHasLabel({gear_name: pk.gear_name}));
	},
})

const OrderDetailListContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(SimpleDataTable)

export default OrderDetailListContainer;


// WEBPACK FOOTER //
// ./src/containers/OrderDetailListContainer.jsx